import React from 'react';
import { motion } from 'framer-motion';
import { Target, Network, FileText, Shield, BarChart3, Globe } from 'lucide-react';
export function Services() {
  const services = [{
    icon: Target,
    title: 'iGaming SEO Domination',
    description: 'Technical SEO, content clusters, and link building tailored specifically for sportsbook verticals and betting markets.'
  }, {
    icon: Network,
    title: 'Affiliate Network Architecture',
    description: 'Building and optimizing high-converting affiliate funnels with advanced tracking systems and attribution models.'
  }, {
    icon: FileText,
    title: 'Odds Page Optimization',
    description: 'Landing pages engineered for maximum player acquisition and first-time deposits with A/B tested conversion flows.'
  }, {
    icon: Shield,
    title: 'Compliance-First Content',
    description: 'SEO content that ranks AND satisfies gambling authority regulations across multiple jurisdictions.'
  }, {
    icon: BarChart3,
    title: 'Data War Room',
    description: 'Real-time dashboards tracking affiliate performance, player LTV, campaign ROI, and competitive intelligence.'
  }, {
    icon: Globe,
    title: 'Market Expansion Intel',
    description: 'Geo-targeted strategies for entering new regulated betting markets with localized SEO and compliance roadmaps.'
  }];
  return <section id="services" className="py-20 felt-texture" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-137">
            Our <span className="text-[#00ff88]" data-id="element-138">Winning Playbook</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-139">
            Specialized services designed exclusively for sports betting
            affiliate marketing
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className="bg-[#0d2818]/60 border border-[#00ff88]/20 rounded-lg p-6 hover:border-[#00ff88]/50 transition-all hover:glow-green" data-id="element-141">
                <div className="flex items-start space-x-4" data-id="element-142">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#00ff88]/10 rounded-lg flex items-center justify-center" data-id="element-143">
                    <Icon className="text-[#00ff88]" size={24} data-id="element-144" />
                  </div>
                  <div className="flex-1" data-id="element-145">
                    <h3 className="text-lg font-bold mb-2" data-id="element-146">{service.title}</h3>
                    <p className="text-gray-400 text-sm" data-id="element-147">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}